var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bg-white border border-primary rounded-3 p-3 mt-3" },
      [
        _c("div", { staticClass: "d-flex align-stretch theme--light" }, [
          _c(
            "div",
            { staticClass: "v-avatar v-list-item__avatar classroom-avatarbox" },
            [
              _c("img", {
                attrs: {
                  "data-v-4e74514c": "",
                  src: "https://popshub.s3.amazonaws.com/uploads/school/image/26/photo-1454165804606-c3d57bc86b40.jpeg",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "small" }, [
            _c("h3", { staticClass: "text-caption fw-bold" }, [
              _vm._v("白先生AI"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "ellipsis-2line" }, [
              _vm._v(
                "\n        残りの日数も少なくなりましたね。前回のテストではちょっと良くなりました。残りの日数も少なくなりましたね。前回のテストではちょっと良くなりました...\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-end" }, [
              _c(
                "a",
                { staticClass: "text-decoration-none", attrs: { href: "#" } },
                [_vm._v("\n          白先生AIと会話する\n        ")]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }